import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"

// Optimistic favorite heart. Flips the heart the instant it's tapped, persists
// in the background, and reverts + toasts on failure — so a favorite never
// triggers a full-page reload (mobile_design.md's canonical live-edit case).
//
// Surface-agnostic: the heart looks different on a card vs the hero overlay vs
// a swipe finder, so each instance passes its own active/inactive COLOR classes
// (the layout classes stay constant) and marks the coloured element as the
// "swatch" target (defaults to the button itself) plus the SVG as "icon".
export default class extends Controller {
  static targets = ["icon", "swatch"]
  static classes = ["active", "inactive"]
  static values = {
    url: String,
    favorited: Boolean
  }

  toggle(event) {
    event.preventDefault()
    const next = !this.favoritedValue
    this.#render(next)
    this.#persist(next)
  }

  #render(favorited) {
    this.favoritedValue = favorited
    const el = this.hasSwatchTarget ? this.swatchTarget : this.element
    const active = this.hasActiveClass ? this.activeClasses : []
    const inactive = this.hasInactiveClass ? this.inactiveClasses : []
    el.classList.remove(...(favorited ? inactive : active))
    el.classList.add(...(favorited ? active : inactive))
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fill-current", favorited)
      this.iconTarget.setAttribute("fill", favorited ? "currentColor" : "none")
    }
    this.element.setAttribute("aria-label", favorited ? "Unfavorite" : "Favorite")
  }

  #persist(favorited) {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.urlValue, {
      method: favorited ? "POST" : "DELETE",
      headers: { "X-CSRF-Token": token, Accept: "text/html" }
    })
      .then((response) => { if (!response.ok && !response.redirected) throw new Error("favorite failed") })
      .catch(() => {
        this.#render(!favorited) // revert the optimistic flip
        showToast("Couldn't update favorite. Try again.", { variant: "error" })
      })
  }
}
